export const validateResponse = (response, actionDescription) => {
    if (!response.ok)
        throw new Error("Received " + response.status + " response when trying to " + actionDescription + ".");

    return response;
};